export type FaqItem = {
  question: string
  answer: string
}

export const serviceFaqs: FaqItem[] = [
  {
    question: 'What does the $1,999 Starter package include?',
    answer:
      'A responsive marketing site of up to five pages, basic on-page SEO, a contact form, mobile layout, and one month of support after launch.',
  },
  {
    question: 'When should I choose the $4,999 Professional package?',
    answer:
      'When you need more pages, a blog or CMS, analytics, and a longer support window. It is the usual fit for growing service businesses that already have a brand and need a site that can rank and convert.',
  },
  {
    question: 'Do you build custom software as well as websites?',
    answer:
      'Yes. We design and ship POS, booking, CRM, invoicing, and internal tools when off-the-shelf software does not match how the business actually runs.',
  },
]
